<template>
  <div>
      <b-alert v-if="error.length" show variant="danger" qid="create-p-error">
        {{ error }}
      </b-alert>

      <!-- BODY MAIN TASK -->
      <b-form qid="create-p-form" @submit.prevent="() => { }"
        v-if="selectedTask && selectedTask.model && currentView == 'default' && selectedTask.code != 'update_measures'">
        <div class="form-container mt-0 mb-2">
          <div class="row mt-1">
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

              <!--Documentation collection && Control Description-->
              <div class="card"
                v-if="!(selectedTask.data_collection_on && (selectedTask.add_control_description && selectedTask.add_control_description == 'No') && selectedTask.add_attachments == 'No')">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('tasks.modal.data_collection_title') }}
                      </div>
                      <div class="col-md-6">
                        <span class="btn float-right btn-ai ml-3 pl-3 mt-0 cursor-pointer"
                          v-if="getClient.aiModule && selectedTask.status != 'completed'"
                          @click="toggleControlDescriptionDrawer">
                          <font-awesome-icon icon="sparkles" />
                          <span>{{ $t('tasks.modal.write_control_description') }}</span>
                        </span>
                      </div>
                      <!-- Sliding div -->
                      <div :class="{ 'drawer-open': isControlDescriptionDrawerOpen }" class="drawer">
                        <div class="mt-2">
                          <div class="col-md-12 text-right m-2">
                            <font-awesome-icon icon="times" class="text-light cursor-pointer"
                              @click="toggleControlDescriptionDrawer" />
                          </div>
                        </div>
                        <div class=" mt-3">
                          <div class="col-md-12 text-center">
                            <font-awesome-icon icon="sparkles" />
                            {{ $t('tasks.modal.write_control_description') }}
                          </div>
                        </div>

                        <div class="text-center mt-5" v-if="ailoading">
                          <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2" />
                          {{ $t('system.loading') }}
                          <p class="text-muted text-center m-3" style="font-size: medium;">
                            {{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
                          </p>
                        </div>

                        <b-alert v-if="errorDescriptionDrawer.length" show variant="danger" qid="create-ai-error"
                          class="m-3">
                          {{ errorDescriptionDrawer }}
                        </b-alert>

                        <ul class="mt-3" style="list-style-type: none; padding-left: 0;font-size:14px;color:#000000;">
                          <li v-if="!ailoading" v-for="(choice, index) in controlDescriptionAi" :key="index"
                            class="p-3">
                            <div class="drawer-textbox formatted-text p-3">
                              <WordByWord :text="choice.message.content" :speed="60" :wordsPerStep="1"
                                :startDelay="index * 120" :trim="true" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </h5>

                  <div v-if="selectedTask.data_collection_on">
                    <div class="mt-3 mb-3">
                      <div>
                        <label style="font-size: medium;">Status</label>
                        <span class="btn btn-secondary btn-sm float-right" @click="reopenFormSubmit"
                          v-if="selectedTask.data_status && selectedTask.data_status === 'completed'">
                          {{ $t('tasks.modal.data_collection_reopen_button') }}
                        </span>
                      </div>

                      <span
                        v-if="(selectedTask.data_status && selectedTask.data_status === 'completed') || selectedTask.status == 'completed'">
                        <font-awesome-icon icon="check-circle" class="icon-success" />
                      </span>
                      <span
                        v-if="selectedTask.data_status && selectedTask.data_status === 'pending' && selectedTask.status != 'completed'"
                        class="pr-1">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                      </span>
                      <span v-if="selectedTask.status == 'completed'">
                        {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                      </span>
                      <span v-else>
                        <span v-if="selectedTask.data_status">
                          {{ $t('system.' + $options.filters.slugify(selectedTask.data_status)) }}
                        </span>
                        <span v-if="!selectedTask.data_status">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                          {{ $t('system.pending') }}
                        </span>
                      </span>

                    </div>
                    <div class="mt-3 mb-3">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="text-bold" style="font-size: medium;">
                            {{ $t('tasks.table.data_collection_assignee') }}:
                            <span class="btn float-right ml-3 pl-3 mt-0 pt-0 text-success cursor-pointer"
                              @click="switchCurrentView('data_collection')">
                              {{ $t('tasks.modal.open_data_collection') }}
                            </span>
                          </div>
                          <div class="mt-1">
                            <span v-if="selectedTask.data_users && selectedTask.data_users.length">
                              <span class="mr-1 text-normal" v-for="(user, user_index) in selectedTask.data_users"
                                :key="user_index">
                                <span qid="profile-photo">
                                  <Avatar :object="user" size="xs"></Avatar>
                                </span>
                              </span>
                            </span>
                            <span v-if="!selectedTask.data_users.length" class="mr-1">
                              <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-1" />
                              {{ $t('risk.missing_input') }}
                            </span>
                            <span class="pl-2 cursor-pointer" @click="showReopenDataCollectionModal"
                              v-if="selectedTask.status != 'completed'">
                              <font-awesome-icon icon="pen" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>


                    <!--Conclusion card: Response-->
                    <b-form-group
                      v-if="selectedTask && selectedTask.add_response_doc && (selectedTask.add_response_doc == 'Optional' || selectedTask.add_response_doc == 'Mandatory' || selectedTask.add_response_doc == 'Auditor')">
                      <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                        {{ $t('tasks.modal.response_label_documentation') }}
                        <span class="text-red"
                          v-if="selectedTask && (selectedTask.add_response_doc == 'Mandatory' || selectedTask.add_response_doc == 'Auditor')">*</span>
                      </label>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="editModeResponseDocMain = !editModeResponseDocMain"
                        v-if="selectedTask.add_response_doc == 'Auditor' && !editModeResponseDocMain && selectedTask.status != 'completed'">
                        <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                      </span>

                      <span class="btn section-btn text-danger cursor-pointer float-right"
                        @click="discardResponseDoc(selectedTask)"
                        v-if="editModeResponseDocMain && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.discard') }}
                      </span>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="updateResponseDoc(selectedTask)"
                        v-if="editModeResponseDocMain && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.save') }}
                      </span>

                      <div v-if="selectedTask.add_response_doc != 'Datepicker'">
                        <multiselect v-if="editModeResponseDocMain && selectedTask.status != 'completed'"
                          v-model="selectedAnswerDoc" qid="assessment-form-response-drop-down" :options="allAnswersDoc"
                          :multiple="false" :taggable="false" label="title"
                          :select-label="$t('system.dropdown_select_label')"
                          :selected-label="$t('system.dropdown_selected_label')"
                          :deselect-label="$t('system.dropdown_deselect_label')"
                          :placeholder="$t('tasks.modal.response_placeholder')">
                          <template slot="option" slot-scope="props">
                            <font-awesome-icon icon="check-circle" class="icon-success"
                              v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                            <font-awesome-icon icon="info-circle" class="icon-info"
                              v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                            <font-awesome-icon icon="times-circle" class="icon-danger"
                              v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                              v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                              v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                              v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                              v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                            <span class="ml-2">
                              {{ props.option.title }}
                            </span>
                          </template>
                          <template slot="singleLabel" slot-scope="props">
                            <font-awesome-icon icon="check-circle" class="icon-success"
                              v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                            <font-awesome-icon icon="info-circle" class="icon-info"
                              v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                            <font-awesome-icon icon="times-circle" class="icon-danger"
                              v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                              v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                              v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                              v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                            <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                              v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                            <span class="ml-2">
                              {{ props.option.title }}
                            </span>
                          </template>
                        </multiselect>

                        <p v-if="(!editModeResponseDocMain && selectedAnswerDoc && selectedAnswerDoc.title) || selectedTask.status == 'completed'"
                          class="">
                          <font-awesome-icon icon="check-circle" class="icon-success"
                            v-if="getIconDoc(selectedTask) == 'Positive'" />
                          <font-awesome-icon icon="times-circle" class="icon-danger"
                            v-if="getIconDoc(selectedTask) == 'Negative'" />
                          <font-awesome-icon icon="info-circle" class="icon-info"
                            v-if="getIconDoc(selectedTask) == 'Neutral'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                            v-if="getIconDoc(selectedTask) == 'Very low'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                            v-if="getIconDoc(selectedTask) == 'Low'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                            v-if="getIconDoc(selectedTask) == 'High'" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                            v-if="getIconDoc(selectedTask) == 'Very high'" />
                          {{ selectedAnswerDoc.title }}
                        </p>

                        <p v-if="!editModeResponseDocMain && !selectedAnswerDoc" qid="no-results-row-rr"
                          class="text-muted">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>

                      <div v-if="selectedTask.add_response_doc == 'Datepicker'">
                        <datepicker v-if="editModeResponseDocMain && selectedTask.status != 'completed'"
                          class="date-picker" qid="assessment-form-response-datepicker" calendar-class="right"
                          v-model="selectedDateDoc" :clear-button="true"
                          :placeholder="$t('tasks.modal.response_label')"></datepicker>

                        <p v-if="!editModeResponseDocMain && selectedDateDoc" class="">
                          <font-awesome-icon icon="calendar-alt" class="mr-1" />
                          {{ selectedDate | formatDate }}
                        </p>

                        <p v-if="!editModeResponseDocMain && !selectedDateDoc" qid="no-results-row-rr"
                          class="text-muted">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>
                    </b-form-group>

                    <label qid="assessment-form-documentation-collection-control-description-label"
                      style="font-size: medium;">
                      {{ $t('tasks.modal.data_collection_comment') }}
                    </label>
                    <div class="pb-2 border-bottom" style="margin-top: -20px;"
                      v-if="selectedTask.data_remarks && selectedTask.data_remarks.length">
                      <div v-if="selectedTask.data_remarks && selectedTask.data_remarks.length > 300">
                        <p v-if="showFullDataCollectionDescription" class="text-formatted">
                          {{ selectedTask.data_remarks }}
                        </p>
                        <p v-if="!showFullDataCollectionDescription" class="text-formatted">
                          {{ selectedTask.data_remarks | truncate(300) }}
                        </p>
                        <div class="text-center mt-3"
                          @click="showFullDataCollectionDescription = !showFullDataCollectionDescription">
                          <span class="cursor-pointer" v-if="!showFullDataCollectionDescription">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullDataCollectionDescription">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="selectedTask.data_remarks && selectedTask.data_remarks.length <= 300"
                        class="text-formatted">
                        {{ selectedTask.data_remarks }}
                      </p>
                    </div>
                    <div v-else class="text-muted pb-2 border-bottom">{{ $t('system.no_results') }}</div>
                  </div>

                  <!--Control description-->
                  <div class="mt-3">
                    <b-form-group
                      v-if="selectedTask && selectedTask.add_control_description && selectedTask.add_control_description == 'Optional' || selectedTask.add_control_description == 'Mandatory'">
                      <label qid="assessment-form-control-description-label" class="mt-3" style="font-size: medium;">
                        {{ $t('tasks.modal.control_description_label') }}
                        <span class="text-red"
                          v-if="selectedTask && selectedTask.add_control_description == 'Mandatory'">*</span>
                        <span qid="profile-photo" v-b-tooltip.hover class="pl-2" title="Output to report">
                          <font-awesome-icon icon="file" style="color:#081F26" />
                        </span>
                      </label>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="editModeControlDescription = !editModeControlDescription"
                        v-if="!editModeControlDescription && selectedTask.status != 'completed'">
                        <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                      </span>

                      <span class="btn section-btn text-danger cursor-pointer float-right"
                        @click="discardControlDescription(selectedTask)"
                        v-if="editModeControlDescription && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.discard') }}
                      </span>

                      <span class="btn section-btn text-success cursor-pointer float-right"
                        @click="updateControlDescription(selectedTask)"
                        v-if="editModeControlDescription && selectedTask.status != 'completed'">
                        {{ $t('tasks.modal.save') }}
                      </span>

                      <b-form-textarea qid="assessment-form-control-description" v-model="taskForm.control_description"
                        v-if="editModeControlDescription && selectedTask.status != 'completed'" rows="6" max-rows="6"
                        :required="selectedTask.add_control_description == 'Mandatory'"
                        :placeholder="$t('tasks.modal.control_description_placeholder')"></b-form-textarea>

                      <div v-if="!editModeControlDescription || selectedTask.status == 'completed'"
                        style="margin-top: -20px;">
                        <div v-if="taskForm.control_description && taskForm.control_description.length > 300">
                          <p v-if="showFullTextControlDescription" class="text-formatted" style="margin-top: -20px;">
                            {{ taskForm.control_description }}
                          </p>

                          <p v-if="!showFullTextControlDescription" class="text-formatted">
                            {{ taskForm.control_description | truncate(300) }}
                          </p>

                          <div class="text-center mt-3"
                            @click="showFullTextControlDescription = !showFullTextControlDescription">
                            <span class="cursor-pointer" v-if="!showFullTextControlDescription">
                              <span class="mr-2">
                                {{ $t('system.view_more') }}
                              </span>
                              <font-awesome-icon icon="chevron-down" />
                            </span>
                            <span class="cursor-pointer" v-if="showFullTextControlDescription">
                              <span class="mr-2">
                                {{ $t('system.view_less') }}
                              </span>
                              <font-awesome-icon icon="chevron-up" />
                            </span>
                          </div>
                        </div>

                        <p v-if="taskForm.control_description && taskForm.control_description.length <= 300"
                          class="text-formatted">
                          {{ taskForm.control_description }}
                        </p>
                        <p v-if="!taskForm.control_description" qid="no-results-row-rr" class="text-muted"
                          style="margin-top: 20px;">
                          {{ $t('system.no_results') }}
                        </p>
                      </div>
                    </b-form-group>
                  </div>

                  <div class="w-100" @dragover.prevent>
                    <div v-show="showDropActive" class="drop-active">
                      <h3>Drop files to upload</h3>
                    </div>
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('attachments.label') }}
                    </label>
                    <span class="float-right">
                      <file-upload v-if="selectedTask.status != 'completed'" ref="uploader" v-model="files" :drop="true"
                        :multiple="true" input-id="task-file" @input="onFileChangeEdit"
                        @dropActive="showDropActiveFunction" @dropInactive="hideDropActiveFunction"
                        class="text-success cursor-pointer float:right mt-3">
                        {{ $t('tasks.modal.add_attachment_label') }}
                      </file-upload>
                    </span>
                  </div>

                  <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                    <li v-for="(item, index) in getMedia('task_and_data_collection')" :key="index"
                      class="text-bold list-item mb-2">
                      <div class="row" style="height:20px;">
                        <div class="col-md-8">
                          <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                            {{ item.full_title }}
                          </a>
                        </div>
                        <div class="actions col-md-4">
                          <div class="float-right">
                            <a :href="item.url" target="_blank" class="btn" qid="download-media">
                              <font-awesome-icon icon="eye" />
                            </a>
                            <a class="btn" @click="downloadMedia(item)" qid="download-media">
                              <font-awesome-icon icon="cloud-download-alt" />
                            </a>
                            <a class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item"
                              v-if="selectedTask.status != 'completed'">
                              <font-awesome-icon icon="trash-alt" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li v-if="!getMedia('task_and_data_collection').length && !selectedTask.linked_media.length"
                      qid="no-results-row-rr" class="">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>
                  </ul>

                  <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                    <li v-for="(item, index) in selectedTask.linked_media" :key="index"
                      class="text-bold list-item mb-2">
                      <div class="row" style="height:20px;">
                        <div class="col-md-8">
                          <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                            {{ item.full_title }}
                          </a>
                        </div>

                        <div class="actions col-md-4">
                          <div class="float-right">
                            <a :href="item.url" target="_blank" class="btn" qid="download-media">
                              <font-awesome-icon icon="eye" />
                            </a>
                            <a class="btn" @click="downloadMedia(item)" qid="download-media">
                              <font-awesome-icon icon="cloud-download-alt" />
                            </a>
                            <a class="btn" @click="openDeleteLinkedAttachmentModal(item)" qid="remove-media-item"
                              v-if="selectedTask.status != 'completed'">
                              <font-awesome-icon icon="trash-alt" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div class="w-100" v-if="allLinkedMediaFiles.length && selectedTask.status != 'completed'">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('attachments.suggested_label') }}

                    </label>
                    <span class="btn text-success cursor-pointer float-right pt-2"
                      @click="updateLinkedMedia(selectedTask)" v-if="selectedTask.status != 'completed'">
                      Add selected
                    </span>
                  </div>
                  <ul class="compact-list" style="list-style-type: none; padding-left: 0;"
                    v-if="allLinkedMediaFiles.length && selectedTask.status != 'completed'">
                    <li v-for="(item, index) in allLinkedMediaFiles" :key="index" class="text-bold list-item mb-2">
                      <div class="row">
                        <span class="col-md-10 pr-0">
                          <a :href="item.url" target="_blank" class="btn btn-link p-0 text-muted" qid="download-media">
                            {{ item.full_title }}
                          </a>
                        </span>
                        <span class="actions pt-1 pl-0 pr-4 col-md-2 text-right" style="float: right;">
                          <input type="checkbox" v-model="selectedLinkedMedia" :value="item" />
                        </span>
                      </div>
                    </li>
                    <li qid="no-results-row-rr" class=""
                      v-if="!allLinkedMediaFiles.length && selectedTask.status != 'completed'">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>
                  </ul>
                </div>
              </div>

              <!--Testing card-->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('tasks.modal.testing') }}
                      </div>
                      <div class="col-md-6">
                        <span class="btn btn-ai float-right ml-3 pl-3 mt-0 cursor-pointer" @click="toggleTestingDrawer"
                          v-if="getClient.aiModule && selectedTask.status != 'completed'">
                          <font-awesome-icon icon="sparkles" />
                          <span>{{ $t('tasks.modal.write_test_plan') }}</span>
                        </span>
                      </div>
                      <!-- Sliding div -->
                      <div :class="{ 'drawer-open': isTestingDrawerOpen }" class="drawer">
                        <div class="mt-2">
                          <div class="col-md-12 text-right m-2">
                            <font-awesome-icon icon="times" class="text-light cursor-pointer"
                              @click="toggleTestingDrawer" />
                          </div>
                        </div>
                        <div class=" mt-3">
                          <div class="col-md-12 text-center">
                            <font-awesome-icon icon="sparkles" />
                            {{ $t('tasks.modal.write_test_plan') }}
                          </div>
                        </div>

                        <div class="text-center mt-5" v-if="ailoading">
                          <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2" />
                          {{ $t('system.loading') }}
                          <p class="text-muted text-center m-3" style="font-size: medium;">
                            {{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
                          </p>
                        </div>

                        <b-alert v-if="errorTestingDrawer.length" show variant="danger" qid="create-ai-error"
                          class="m-3">
                          {{ errorTestingDrawer }}
                        </b-alert>

                        <ul class="mt-3" style="list-style-type: none; padding-left: 0;font-size:14px;color:#000000;">
                          <li v-if="!ailoading" v-for="(choice, index) in testPlanAi" :key="index" class="p-3">
                            <div class="drawer-textbox formatted-text p-3">
                              <WordByWord :text="choice.message.content" :speed="60" :wordsPerStep="1"
                                :startDelay="index * 120" :trim="true" />
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </h5>

                  <b-form-group
                      v-if="selectedTask && selectedTask.add_performed_text && selectedTask.add_performed_text == 'Optional' || selectedTask.add_performed_text == 'Mandatory'">

                    <label qid="assessment-form-performed-test-label" style="font-size: medium;" class="mt-3">
                      {{ $t('tasks.modal.performed_test_label') }}
                      <span class="text-red"
                            v-if="selectedTask && selectedTask.add_performed_text == 'Mandatory'">*</span>
                      <span qid="profile-photo" v-b-tooltip.hover class="pl-2" title="Output to report">
                        <font-awesome-icon icon="file" style="color:#081F26" />
                      </span>
                    </label>

                    <span class="btn text-success cursor-pointer float-right"
                          @click="editModePerformedTest = !editModePerformedTest"
                          v-if="!editModePerformedTest && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn text-danger cursor-pointer float-right" @click="discardPerformedTest(selectedTask)"
                          v-if="editModePerformedTest && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn text-success cursor-pointer float-right" @click="updatePerformedTest(selectedTask)"
                          v-if="editModePerformedTest && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <b-form-textarea qid="assessment-form-performed-test" v-model="taskForm.performed_text"
                                     v-if="editModePerformedTest && selectedTask.status != 'completed'" rows="6" max-rows="6"
                                     :required="selectedTask.add_performed_text == 'Mandatory'"
                                     :placeholder="$t('tasks.modal.performed_test_placeholder')"></b-form-textarea>

                    <div v-if="!editModePerformedTest || selectedTask.status == 'completed'" style="margin-top: -20px;">
                      <div v-if="taskForm.performed_text && taskForm.performed_text.length > 300">
                        <p v-if="showFullTextPerformedTest" class="text-formatted">
                          {{ taskForm.performed_text }}
                        </p>

                        <p v-if="!showFullTextPerformedTest" class="text-formatted">
                          {{ taskForm.performed_text | truncate(300) }}
                        </p>

                        <div class="text-center mt-3" @click="showFullTextPerformedTest = !showFullTextPerformedTest">
                          <span class="cursor-pointer" v-if="!showFullTextPerformedTest">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullTextPerformedTest">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="taskForm.performed_text && taskForm.performed_text.length <= 300" class="text-formatted">
                        {{ taskForm.performed_text }}
                      </p>
                      <p v-if="!taskForm.performed_text" qid="no-results-row-rr" class="text-muted"
                         style="margin-top: 20px;">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>

                  <div class="w-100" v-if="selectedTask.status != 'completed' || tests.length">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;">
                      {{ $t('testing.title') }}
                    </label>
                    <span class="float-right">
                      <button class="btn ml-3 pl-3 text-success" @click="showTestCreateModal()"
                        v-if="selectedTask.status != 'completed'">
                        <font-awesome-icon icon="plus" /> {{ $t('testing.form.create_new_test') }}
                      </button>
                    </span>
                  </div>

                  <ul class="list-secondary mt-2" style="list-style-type: none; padding-left: 0;"
                    v-if="selectedTask.status != 'completed' || tests.length">
                    <li v-for="object in tests" class="text-bold list-item testing-list-item mb-2">
                      <span class="status-container">
                        <div class="status-icon">
                          <span v-if="object.status == 'pending'">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                          </span>
                          <span v-if="object.status == 'documentation_collection_completed'">
                            <font-awesome-icon icon="info-circle" class="icon-info" />
                          </span>
                          <span v-if="object.status == 'passed'">
                            <font-awesome-icon icon="check-circle" class="icon-success" />
                          </span>
                          <span v-if="object.status == 'failed'">
                            <font-awesome-icon icon="times-circle" class="icon-danger" />
                          </span>
                        </div>
                        <div class="status-button">
                          <button v-if="object" @click="openTestModal(object)" qid="observation-name-link"
                            class="btn btn-link text-left">
                            {{ object.name }}
                          </button>
                        </div>
                      </span>
                      <span class="testing-actions" v-if="selectedTask.status != 'completed'">
                        <span class="btn cursor-pointer" @click="showEditTestModal(object)"
                          qid="delete-s-cancel-button">
                          <span>
                            <font-awesome-icon icon="pen" />
                          </span>
                        </span>
                        <span class="btn cursor-pointer" @click="showTestConfirmDeleteModal(object)">
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                      </span>
                    </li>

                    <li v-if="!loadingTests && tests && !tests.length" qid="no-results-row-rr" class="">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>

                    <li v-if="loadingTests">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </li>
                  </ul>

                  <b-form-group v-if="selectedTask && (selectedTask.add_testing_notes === 'Optional' || selectedTask.add_testing_notes === 'Mandatory')">
                    <label qid="assessment-form-performed-test-label" style="font-size: medium;" class="mt-1">
                      {{ $t('tasks.modal.testing_notes_label') }}
                      <span class="text-red"
                            v-if="selectedTask && selectedTask.add_testing_notes == 'Mandatory'">*</span>
                    </label>

                    <span class="btn text-success cursor-pointer float-right"
                          @click="editModeTestingNotes = !editModeTestingNotes"
                          v-if="!editModeTestingNotes && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn text-danger cursor-pointer float-right" @click="discardTestingNotes(selectedTask)"
                          v-if="editModeTestingNotes && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn text-success cursor-pointer float-right" @click="updateTestingNotes(selectedTask)"
                          v-if="editModeTestingNotes && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <b-form-textarea qid="assessment-form-performed-test" v-model="taskForm.testing_notes"
                                     v-if="editModeTestingNotes && selectedTask.status != 'completed'" rows="6" max-rows="6"
                                     :required="selectedTask.add_performed_text == 'Mandatory'"
                                     :placeholder="$t('tasks.modal.testing_notes_placeholder')"></b-form-textarea>

                    <div v-if="!editModeTestingNotes || selectedTask.status == 'completed'" style="margin-top: -20px;">
                      <div v-if="taskForm.testing_notes && taskForm.testing_notes.length > 300">
                        <p v-if="showFullTextTestingNotes" class="text-formatted">
                          {{ taskForm.testing_notes }}
                        </p>

                        <p v-if="!showFullTextTestingNotes" class="text-formatted">
                          {{ taskForm.testing_notes | truncate(300) }}
                        </p>

                        <div class="text-center mt-3" @click="showFullTextTestingNotes = !showFullTextTestingNotes">
                          <span class="cursor-pointer" v-if="!showFullTextTestingNotes">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullTextTestingNotes">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="taskForm.testing_notes && taskForm.testing_notes.length <= 300" class="text-formatted">
                        {{ taskForm.testing_notes }}
                      </p>
                      <p v-if="!taskForm.testing_notes" qid="no-results-row-rr" class="text-muted"
                         style="margin-top: 20px;">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>

                </div>
              </div>

            </div>

            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
              <div v-if="selectedTask.data_collection_on">
                <AssessmentGlobalSingleTaskModalChatNotesCard />
              </div>

              <!--Conclusion card-->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('tasks.modal.conclusion_and_observatons') }}
                      </div>
                      <div class="col-md-6">
                        <span class="btn btn-ai float-right ml-3 pl-3 mt-0 cursor-pointer"
                          @click="toggleFullAnalystDrawer" v-if="getClient.aiModule">
                          <font-awesome-icon icon="sparkles" />
                          <span>{{ $t('tasks.modal.full_analyst') }}</span>
                        </span>


                        <!-- Sliding div -->
                        <div :class="{ 'drawer-open': isFullAnalystDrawerOpen }" class="drawer">
                          <div class="mt-2">
                            <div class="col-md-12 text-right m-2">
                              <font-awesome-icon icon="times" class="text-light cursor-pointer"
                                @click="toggleFullAnalystDrawer" />
                            </div>
                          </div>
                          <div class=" mt-3">
                            <div class="col-md-12 text-center">
                              <font-awesome-icon icon="sparkles" />
                              {{ $t('tasks.modal.full_analyst') }}
                            </div>
                          </div>

                          <div class="text-center mt-5" v-if="ailoading">
                            <font-awesome-icon icon="spinner" size="lg" class="fa-spin mr-2" />
                            {{ $t('system.loading') }}
                            <p class="text-muted text-center m-3" style="font-size: medium;">
                              {{ $t('tasks.modal.please_wait_while_processing') }} ({{ timeLeft }}s)
                            </p>
                          </div>

                          <b-alert v-if="errorFullAnalystDrawer.length" show variant="danger" qid="create-ai-error"
                            class="m-3">
                            {{ errorFullAnalystDrawer }}
                          </b-alert>

                          <ul class="mt-3" style="list-style-type: none; padding-left: 0;font-size:14px;color:#000000;">
                            <li v-if="!ailoading" v-for="(choice, index) in fullAnalystAi" :key="index" class="p-3">
                              <div class="drawer-textbox formatted-text p-3">
                                <WordByWord :text="choice.message.content" :speed="60" :wordsPerStep="1"
                                  :startDelay="index * 120" :trim="true" />
                              </div>
                            </li>
                          </ul>
                        </div>

                      </div>
                    </div>
                  </h5>

                  <!--Conclusion card: Response-->
                  <b-form-group
                    v-if="selectedTask && selectedTask.add_response && selectedTask.add_response == 'Optional' || selectedTask.add_response == 'Mandatory'">
                    <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                      {{ $t('tasks.modal.response_label') }}
                      <span class="text-red" v-if="selectedTask && selectedTask.add_response == 'Mandatory'">*</span>
                    </label>

                    <span class="btn section-btn text-success cursor-pointer float-right"
                      @click="editModeResponse = !editModeResponse"
                      v-if="!editModeResponse && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn section-btn text-danger cursor-pointer float-right"
                      @click="discardResponse(selectedTask)"
                      v-if="editModeResponse && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn section-btn text-success cursor-pointer float-right"
                      @click="updateResponse(selectedTask)"
                      v-if="editModeResponse && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <div v-if="selectedTask.response_type != 'Datepicker'">
                      <multiselect v-if="editModeResponse && selectedTask.status != 'completed'"
                        v-model="selectedAnswer" qid="assessment-form-response-drop-down" :options="allAnswers"
                        :multiple="false" :taggable="false" label="title"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        :placeholder="$t('tasks.modal.response_placeholder')">
                        <template slot="option" slot-scope="props">
                          <font-awesome-icon icon="check-circle" class="icon-success"
                            v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                          <font-awesome-icon icon="info-circle" class="icon-info"
                            v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                          <font-awesome-icon icon="times-circle" class="icon-danger"
                            v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                            v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                            v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                            v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                            v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                          <span class="ml-2">
                            {{ props.option.title }}
                          </span>
                        </template>
                        <template slot="singleLabel" slot-scope="props">
                          <font-awesome-icon icon="check-circle" class="icon-success"
                            v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                          <font-awesome-icon icon="info-circle" class="icon-info"
                            v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                          <font-awesome-icon icon="times-circle" class="icon-danger"
                            v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                            v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                            v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                            v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                          <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                            v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                          <span class="ml-2">
                            {{ props.option.title }}
                          </span>
                        </template>
                      </multiselect>

                      <p v-if="(!editModeResponse && selectedAnswer && selectedAnswer.title) || selectedTask.status == 'completed'"
                        class="">
                        <font-awesome-icon icon="check-circle" class="icon-success"
                          v-if="getIcon(selectedTask) == 'Positive'" />
                        <font-awesome-icon icon="times-circle" class="icon-danger"
                          v-if="getIcon(selectedTask) == 'Negative'" />
                        <font-awesome-icon icon="info-circle" class="icon-info"
                          v-if="getIcon(selectedTask) == 'Neutral'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                          v-if="getIcon(selectedTask) == 'Very low'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                          v-if="getIcon(selectedTask) == 'Low'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                          v-if="getIcon(selectedTask) == 'High'" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                          v-if="getIcon(selectedTask) == 'Very high'" />
                        {{ selectedAnswer.title }}
                      </p>

                      <p v-if="!editModeResponse && !selectedAnswer" qid="no-results-row-rr" class="text-muted">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>

                    <div v-if="selectedTask.response_type == 'Datepicker'">
                      <datepicker v-if="editModeResponse && selectedTask.status != 'completed'" class="date-picker"
                        qid="assessment-form-response-datepicker" calendar-class="right" v-model="selectedDate"
                        :clear-button="true" :placeholder="$t('tasks.modal.response_label')"></datepicker>

                      <p v-if="!editModeResponse && selectedDate" class="">
                        <font-awesome-icon icon="calendar-alt" class="mr-1" />
                        {{ selectedDate | formatDate }}
                      </p>

                      <p v-if="!editModeResponse && !selectedDate" qid="no-results-row-rr" class="text-muted">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>
                  <!--Conclusion card: Conclusion-->
                  <b-form-group
                    v-if="selectedTask && selectedTask.add_description && selectedTask.add_description == 'Optional' || selectedTask.add_description == 'Mandatory'">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('tasks.modal.remarks_label') }}
                      <span class="text-red" v-if="selectedTask && selectedTask.add_description == 'Mandatory'">*</span>
                      <span qid="profile-photo" v-b-tooltip.hover class="pl-2" title="Output to report">
                        <font-awesome-icon icon="file" style="color:#081F26" />
                      </span>
                    </label>

                    <span class="btn section-btn text-success cursor-pointer float-right mt-2"
                      @click="editModeConclusion = !editModeConclusion"
                      v-if="!editModeConclusion && selectedTask.status != 'completed'">
                      <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                    </span>

                    <span class="btn section-btn text-danger cursor-pointer float-right"
                      @click="discardConclusion(selectedTask)"
                      v-if="editModeConclusion && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.discard') }}
                    </span>

                    <span class="btn section-btn text-success cursor-pointer float-right"
                      @click="updateConclusion(selectedTask)"
                      v-if="editModeConclusion && selectedTask.status != 'completed'">
                      {{ $t('tasks.modal.save') }}
                    </span>

                    <b-form-textarea qid="assessment-form-conclusion" v-model="taskForm.remarks"
                      v-if="editModeConclusion && selectedTask.status != 'completed'" rows="6" max-rows="6"
                      :placeholder="$t('tasks.modal.remarks_placeholder')"></b-form-textarea>

                    <div v-if="!editModeConclusion" style="margin-top: -20px;">
                      <div v-if="taskForm.remarks && taskForm.remarks.length > 300">
                        <p v-if="showFullTextConclusion" class="text-formatted">
                          {{ taskForm.remarks }}
                        </p>

                        <p v-if="!showFullTextConclusion" class="text-formatted">
                          {{ taskForm.remarks | truncate(300) }}
                        </p>

                        <div class="text-center mt-3" @click="showFullTextConclusion = !showFullTextConclusion">
                          <span class="cursor-pointer" v-if="!showFullTextConclusion">
                            <span class="mr-2">
                              {{ $t('system.view_more') }}
                            </span>
                            <font-awesome-icon icon="chevron-down" />
                          </span>
                          <span class="cursor-pointer" v-if="showFullTextConclusion">
                            <span class="mr-2">
                              {{ $t('system.view_less') }}
                            </span>
                            <font-awesome-icon icon="chevron-up" />
                          </span>
                        </div>
                      </div>

                      <p v-if="taskForm.remarks && taskForm.remarks.length <= 300" class="text-formatted">
                        {{ taskForm.remarks }}
                      </p>

                      <p v-if="!editModeConclusion && !taskForm.remarks" qid="no-results-row-rr" class="text-muted"
                        style="margin-top: 20px;">
                        {{ $t('system.no_results') }}
                      </p>
                    </div>
                  </b-form-group>

                  <div class="w-100" v-if="selectedTask.status != 'completed' || sTableItems.length">
                    <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                      {{ $t('projects.observations.title') }}
                    </label>
                    <span class="float-right">
                      <CreateObservationModal :object="selectedTask.project" :task="selectedTask" type="global"
                        @updated="loadObservations(selectedTask.id)"
                        v-if="currentView != 'data_collection' && selectedTask.code != 'update_measures' && selectedTask.status != 'completed'">
                      </CreateObservationModal>
                    </span>
                  </div>
                  <ObservationViewModal :object="selectedObservation" :project="selectedTask.project"
                    :showModal="viewObservationModal" @closeViewModal="handleCloseViewModal"></ObservationViewModal>
                  <ul class="list-secondary" style="list-style-type: none; padding-left: 0;">
                    <li v-for="object in sTableItems" class="text-bold list-item mb-2">
                      <span>
                        <button v-if="object" @click="openViewModal(object)" qid="observation-name-link"
                          class="btn btn-link text-left">
                          <font-awesome-icon size="lg" icon="binoculars" class="mr-1" />
                          {{ object.name }}
                        </button>

                      </span>
                      <span class="actions" style="float: right;">
                        <span class="btn" @click="showEditModal(object)" qid="delete-s-cancel-button"
                          v-if="selectedTask.status != 'completed' && (selectedTask.project.status != 'closed' && selectedTask.project.status != 'completed')">
                          <span>
                            <font-awesome-icon icon="pen" />
                          </span>
                        </span>
                        <span class="btn" @click="showSConfirmDeleteModal(object)"
                          v-if="selectedTask.status != 'completed' && (selectedTask.project.status != 'closed' && selectedTask.project.status != 'completed')">
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                      </span>
                    </li>
                    <li qid="no-results-row-rr" class=""
                      v-if="!loadingObservations && sTableItems && !sTableItems.length">
                      <div class="text-muted">{{ $t('system.no_results') }}</div>
                    </li>

                    <li v-if="loadingObservations">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </li>
                  </ul>

                </div>
              </div>

              <!--Quality control card-->
              <div class="card">
                <div class="card-body">
                  <h5 class="card-title border-bottom pb-2">
                    <div class="row">
                      <div class="col-md-6">
                        {{ $t('system.quality_control') }}
                      </div>
                      <div class="col-md-6">
                        <b-button class="float-right" variant="link"
                          v-if="selectedTask.qa_status != '' && selectedTask.code != 'system_impact_assessment' && currentView != 'data_collection'"
                          @click="showQaLog" :disabled="buttonDisabled" qid="task-modal-save_without_complete-button">
                          {{ $t('system.quality_control_log') }}
                        </b-button>
                      </div>
                    </div>
                  </h5>
                  <div>
                    <div v-if="qaComments && qaComments.length" class="pt-3">
                      <div v-for="(comment, comment_index) in qaComments" :key="comment_index" class="mb-4">
                        <div class="row">
                          <div class="col-md-6">
                            {{ comment.user.name }}
                          </div>
                          <div class="col-md-6 text-right">
                            <span v-if="comment.type == 'accepted'"><font-awesome-icon icon="check-circle"
                                class="icon-success" /> {{ $t('system.accepted') }}</span>
                            <span v-if="comment.type == 'rejected'"><font-awesome-icon icon="times-circle"
                                class="icon-danger" /> {{ $t('system.rejected') }}</span>
                            <span v-if="comment.type == 'completed'"><font-awesome-icon icon="info-circle"
                                class="icon-info" /> {{ $t('system.completed') }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="!loadingQaComments && qaComments && !qaComments.length" qid="no-results-row-rr"
                      class="text-muted">
                      {{ $t('system.no_results') }}
                    </div>

                    <div v-if="loadingQaComments">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin" />
                    </div>
                  </div>
                </div>
              </div>


            </div>

            <!-- System risk task form -->
            <div class="col-sm-6" v-if="selectedTask.code == 'system_impact_assessment'">
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.confidentiality.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect v-model="selectedConfidentialityImpact" :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')" label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact">
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.integrity.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect v-model="selectedIntegrityImpact" :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')" label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact">
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.availability.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect v-model="selectedAvailabilityImpact" :options="impactItems"
                  :placeholder="$t('processes.risk.impact_placeholder')" label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')" qid="confidentiality-form-impact">
                </multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rto_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input qid="create-s-form-name" type="number" min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')" v-model="taskForm.rto"></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect v-model="rtoInterval" :options="intervalOptions"
                      :placeholder="$t('projects.schedule.interval_placeholder')" label="text"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')" qid="create-p-form-pg"></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rpo_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input qid="create-s-form-name" type="number" min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')" v-model="taskForm.rpo"></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect v-model="rpoInterval" :options="intervalOptions"
                      :placeholder="$t('projects.schedule.interval_placeholder')" label="text"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')" qid="create-p-form-pg"></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.remarks_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-textarea qid="create-s-form-description" v-model="taskForm.remarks" rows="6" max-rows="6"
                  :required="selectedTask.add_description == 'Mandatory'"
                  :placeholder="$t('tasks.modal.remarks_placeholder')"></b-form-textarea>
              </b-form-group>
            </div>

          </div>
        </div>
      </b-form>

      <!--Documentation collection modal: First column-->
      <div class="form-container mt-0 mb-2"
        v-if="selectedTask && selectedTask.model && currentView == 'data_collection' && selectedTask.code != 'update_measures'">
        <div class="row mt-1">
          <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

            <!-- Documentation collection modal: Documentation collection card -->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title border-bottom pb-2"> {{ $t('tasks.modal.data_collection_title') }}</h5>


                <!--Conclusion card: Response-->
                <b-form-group
                  v-if="selectedTask && selectedTask.add_response_doc && (selectedTask.add_response_doc == 'Optional' || selectedTask.add_response_doc == 'Mandatory')">
                  <label qid="assessment-form-response-label" style="font-size: medium;" class="mt-3">
                    {{ $t('tasks.modal.response_label') }}
                    <span class="text-red" v-if="selectedTask && selectedTask.add_response_doc == 'Mandatory'">*</span>
                  </label>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="editModeResponseDoc = !editModeResponseDoc"
                    v-if="!editModeResponseDoc && selectedTask.status != 'completed'">
                    <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                  </span>

                  <span class="btn section-btn text-danger cursor-pointer float-right"
                    @click="discardResponseDoc(selectedTask)"
                    v-if="editModeResponseDoc && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.discard') }}
                  </span>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="updateResponseDoc(selectedTask)"
                    v-if="editModeResponseDoc && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.save') }}
                  </span>

                  <div v-if="selectedTask.add_response_doc != 'Datepicker'">
                    <multiselect v-if="editModeResponseDoc && selectedTask.status != 'completed'"
                      v-model="selectedAnswerDoc" qid="assessment-form-response-drop-down" :options="allAnswersDoc"
                      :multiple="false" :taggable="false" label="title"
                      :select-label="$t('system.dropdown_select_label')"
                      :selected-label="$t('system.dropdown_selected_label')"
                      :deselect-label="$t('system.dropdown_deselect_label')"
                      :placeholder="$t('tasks.modal.response_placeholder')">
                      <template slot="option" slot-scope="props">
                        <font-awesome-icon icon="check-circle" class="icon-success"
                          v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                        <font-awesome-icon icon="info-circle" class="icon-info"
                          v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                        <font-awesome-icon icon="times-circle" class="icon-danger"
                          v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                          v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                          v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                          v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                          v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                        <span class="ml-2">
                          {{ props.option.title }}
                        </span>
                      </template>
                      <template slot="singleLabel" slot-scope="props">
                        <font-awesome-icon icon="check-circle" class="icon-success"
                          v-if="props.option.value.value == 'Positive'" style="border-radius:50%;" />
                        <font-awesome-icon icon="info-circle" class="icon-info"
                          v-if="props.option.value.value == 'Neutral'" style="border-radius:50%;" />
                        <font-awesome-icon icon="times-circle" class="icon-danger"
                          v-if="props.option.value.value == 'Negative'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                          v-if="props.option.value.value == 'Very low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                          v-if="props.option.value.value == 'Low'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                          v-if="props.option.value.value == 'High'" style="border-radius:50%;" />
                        <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                          v-if="props.option.value.value == 'Very high'" style="border-radius:50%;" />
                        <span class="ml-2">
                          {{ props.option.title }}
                        </span>
                      </template>
                    </multiselect>

                    <p v-if="(!editModeResponseDoc && selectedAnswerDoc && selectedAnswerDoc.title) || selectedTask.status == 'completed'"
                      class="">
                      <font-awesome-icon icon="check-circle" class="icon-success"
                        v-if="getIconDoc(selectedTask) == 'Positive'" />
                      <font-awesome-icon icon="times-circle" class="icon-danger"
                        v-if="getIconDoc(selectedTask) == 'Negative'" />
                      <font-awesome-icon icon="info-circle" class="icon-info"
                        v-if="getIconDoc(selectedTask) == 'Neutral'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-1'"
                        v-if="getIconDoc(selectedTask) == 'Very low'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-3'"
                        v-if="getIconDoc(selectedTask) == 'Low'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-9'"
                        v-if="getIconDoc(selectedTask) == 'High'" />
                      <font-awesome-icon icon="exclamation-triangle" :class="'risk-16'"
                        v-if="getIconDoc(selectedTask) == 'Very high'" />
                      {{ selectedAnswerDoc.title }}
                    </p>

                    <p v-if="!editModeResponseDoc && !selectedAnswerDoc" qid="no-results-row-rr" class="text-muted">
                      {{ $t('system.no_results') }}
                    </p>
                  </div>

                  <div v-if="selectedTask.add_response_doc == 'Datepicker'">
                    <datepicker v-if="editModeResponseDoc && selectedTask.status != 'completed'" class="date-picker"
                      qid="assessment-form-response-datepicker" calendar-class="right" v-model="selectedDateDoc"
                      :clear-button="true" :placeholder="$t('tasks.modal.response_label')"></datepicker>

                    <p v-if="!editModeResponseDoc && selectedDateDoc" class="">
                      <font-awesome-icon icon="calendar-alt" class="mr-1" />
                      {{ selectedDate | formatDate }}
                    </p>

                    <p v-if="!editModeResponseDoc && !selectedDateDoc" qid="no-results-row-rr" class="text-muted">
                      {{ $t('system.no_results') }}
                    </p>
                  </div>
                </b-form-group>

                <!-- Documentation collection modal: Control description -->
                <b-form-group
                  v-if="selectedTask && selectedTask.data_collection_add_description && selectedTask.data_collection_add_description == 'Optional' || selectedTask.data_collection_add_description == 'Mandatory'">
                  <label qid="assessment-form-documentation-collection-control-description-label"
                    style="font-size: medium;" class="mt-3">
                    {{ $t('tasks.modal.comment_label') }}
                    <span class="text-red"
                      v-if="selectedTask && selectedTask.data_collection_add_description == 'Mandatory'">*</span>
                  </label>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="editModeControlDescriptionDocumentationCollection = !editModeControlDescriptionDocumentationCollection"
                    v-if="!editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'">
                    <font-awesome-icon icon="pen" class="text-success" /> {{ $t('system.edit') }}
                  </span>

                  <span class="btn section-btn text-danger cursor-pointer float-right"
                    @click="discardDataRemarks(selectedTask)"
                    v-if="editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.discard') }}
                  </span>

                  <span class="btn section-btn text-success cursor-pointer float-right"
                    @click="updateDataRemarks(selectedTask)"
                    v-if="editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'">
                    {{ $t('tasks.modal.save') }}
                  </span>


                  <b-form-textarea qid="assessment-form-documentation-collection-control-description"
                    v-model="taskForm.data_remarks"
                    v-if="editModeControlDescriptionDocumentationCollection && selectedTask.status != 'completed'"
                    rows="6" max-rows="6" :placeholder="$t('tasks.modal.comment_label')"></b-form-textarea>

                  <div v-if="!editModeControlDescriptionDocumentationCollection" style="margin-top: -20px;">
                    <div v-if="taskForm.data_remarks && taskForm.data_remarks.length > 300">
                      <p v-if="showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                        {{ taskForm.data_remarks }}
                      </p>

                      <p v-if="!showFullTextControlDescriptionDocumentationCollection" class="text-formatted">
                        {{ taskForm.data_remarks | truncate(300) }}
                      </p>

                      <div class="text-center mt-3"
                        @click="showFullTextControlDescriptionDocumentationCollection = !showFullTextControlDescriptionDocumentationCollection">
                        <span class="cursor-pointer" v-if="!showFullTextControlDescriptionDocumentationCollection">
                          <span class="mr-2">
                            {{ $t('system.view_more') }}
                          </span>
                          <font-awesome-icon icon="chevron-down" />
                        </span>
                        <span class="cursor-pointer" v-if="showFullTextControlDescriptionDocumentationCollection">
                          <span class="mr-2">
                            {{ $t('system.view_less') }}
                          </span>
                          <font-awesome-icon icon="chevron-up" />
                        </span>
                      </div>
                    </div>

                    <p v-if="taskForm.data_remarks && taskForm.data_remarks.length <= 300" class="text-formatted">
                      {{ taskForm.data_remarks }}
                    </p>
                    <p v-if="!taskForm.data_remarks" qid="no-results-row-rr" class="text-muted"
                      style="margin-top: 20px;">
                      {{ $t('system.no_results') }}
                    </p>
                  </div>
                </b-form-group>

                <!-- Documentation collection modal: Attachments -->
                <div class="w-100" @dragover.prevent>
                  <div v-show="showDropActive" class="drop-active">
                    <h3>Drop files to upload</h3>
                  </div>
                  <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                    {{ $t('attachments.label') }}
                  </label>
                  <span class="float-right">
                    <file-upload ref="uploader" v-model="data_collection_files" :drop="true" :multiple="true"
                      input-id="task-file" @input="onDataFileChange" @dropActive="showDropActiveFunction"
                      @dropInactive="hideDropActiveFunction" v-if="selectedTask.status != 'completed'"
                      class="text-success cursor-pointer float:right mt-3">
                      {{ $t('tasks.modal.add_attachment_label') }}
                    </file-upload>
                  </span>
                </div>

                <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                  <li v-for="(item, index) in getMedia('data_documents')" :key="index" class="text-bold list-item mb-2">
                    <div class="row" style="height:20px;">
                      <div class="col-md-8">
                        <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                          {{ item.full_title }}
                        </a>
                      </div>
                      <div class="actions col-md-4">
                        <div class="float-right">
                          <a :href="item.url" target="_blank" class="btn" qid="download-media">
                            <font-awesome-icon icon="eye" />
                          </a>
                          <a class="btn" @click="downloadMedia(item)" qid="download-media">
                            <font-awesome-icon icon="cloud-download-alt" />
                          </a>
                          <a class="btn" @click="openDeleteAttachmentModal(item)" qid="remove-media-item"
                            v-if="selectedTask.status != 'completed'">
                            <font-awesome-icon icon="trash-alt" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li v-if="!getMedia('data_documents').length && !selectedTask.linked_media.length"
                    qid="no-results-row-rr" class="">
                    <div class="text-muted">{{ $t('system.no_results') }}</div>
                  </li>
                </ul>

                <ul class="compact-list" style="list-style-type: none; padding-left: 0;">
                  <li v-for="(item, index) in selectedTask.linked_media" :key="index" class="text-bold list-item mb-2">
                    <div class="row" style="height:20px;">
                      <div class="col-md-8">
                        <a :href="item.url" target="_blank" class="btn btn-link p-0" qid="download-media">
                          {{ item.full_title }}
                        </a>
                      </div>

                      <div class="actions col-md-4">
                        <div class="float-right">
                          <a :href="item.url" target="_blank" class="btn" qid="download-media">
                            <font-awesome-icon icon="eye" />
                          </a>
                          <a class="btn" @click="downloadMedia(item)" qid="download-media">
                            <font-awesome-icon icon="cloud-download-alt" />
                          </a>
                          <a class="btn" @click="openDeleteLinkedAttachmentModal(item)" qid="remove-media-item"
                            v-if="selectedTask.data_status != 'completed'">
                            <font-awesome-icon icon="trash-alt" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>

                <div class="w-100" v-if="allLinkedDataMediaFiles.length && selectedTask.data_status != 'completed'">
                  <label qid="assessment-form-conclusion-label" style="font-size: medium;" class="mt-3">
                    {{ $t('attachments.suggested_label') }}
                  </label>
                  <span class="btn text-success cursor-pointer float-right pt-2"
                    @click="updateLinkedDataMedia(selectedTask)" v-if="selectedTask.data_status != 'completed'">
                    Add selected
                  </span>
                </div>
                <ul class="list-secondary" style="list-style-type: none; padding-left: 0;"
                  v-if="allLinkedDataMediaFiles.length && selectedTask.data_status != 'completed'">
                  <li v-for="(item, index) in allLinkedDataMediaFiles" :key="index" class="text-bold list-item mb-2">
                    <div class="row">
                      <span class="col-md-10 pr-0">
                        <a :href="item.url" target="_blank" class="btn btn-link p-0 text-muted" qid="download-media">
                          {{ item.full_title }}
                        </a>
                      </span>
                      <span class="actions pt-1 pl-0 pr-4 col-md-2 text-right" style="float: right;">
                        <input type="checkbox" v-model="selectedLinkedDataMedia" :value="item" />
                      </span>
                    </div>
                  </li>
                  <li qid="no-results-row-rr" class=""
                    v-if="!allLinkedDataMediaFiles.length && selectedTask.data_status != 'completed'">
                    <div class="text-muted">{{ $t('system.no_results') }}</div>
                  </li>
                </ul>
              </div>
            </div>

            <!--Documentation collection modal: Testing card-->
            <div class="card" v-if="tests.length">
              <div class="card-body">
                <h5 class="card-title border-bottom pb-2">
                  <div class="row">
                    <div class="col-md-6">
                      {{ $t('tasks.modal.testing') }}
                    </div>
                  </div>
                </h5>

                <div class="w-100">
                  <label qid="assessment-form-conclusion-label" style="font-size: medium;">
                    {{ $t('testing.title') }}
                  </label>

                </div>
                <ul class="list-secondary mt-2" style="list-style-type: none; padding-left: 0;">
                  <li v-for="object in tests" class="text-bold list-item testing-list-item mb-2">
                    <span class="status-container">
                      <div class="status-icon">
                        <span v-if="object.status == 'pending'">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-6" />
                        </span>
                        <span v-if="object.status == 'documentation_collection_completed'">
                          <font-awesome-icon icon="check-circle" class="icon-success" />
                        </span>
                        <span v-if="object.status == 'passed'">
                          <font-awesome-icon icon="check-circle" class="icon-success" />
                        </span>
                        <span v-if="object.status == 'failed'">
                          <font-awesome-icon icon="check-circle" class="icon-success" />
                        </span>
                      </div>
                      <div class="status-button">
                        <button v-if="object" @click="openTestModal(object, 'data')" qid="observation-name-link"
                          class="btn btn-link text-left">
                          {{ object.name }}
                        </button>
                      </div>
                    </span>
                  </li>
                  <li qid="no-results-row-rr" class="" v-if="!tests.length">
                    <div class="text-muted">{{ $t('system.no_results') }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!--Documentation collection modal: Second column-->
          <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
            <!--Documentation collection modal: Chat Card-->
            <div class="card">
              <div class="card-body">
                <h5 class="card-title border-bottom pb-2" style="margin-bottom: 0;"> {{ $t('tasks.modal.data_collection_chat_title') }}</h5>

                <div class="chat-message-area-wrap">
                  <div class="form-control scrollable-height-260 pt-3 chat-message-area" ref="chatContainer">
                    <div v-if="previousComments && previousComments.length" style="width: 100%;">
                      <div
                        v-for="(comment, comment_index) in previousComments"
                        class="mt-3"
                        :key="comment_index"
                      >
                        <div :class="['chat-row', { 'chat-row-self': isCommentOwner(comment), 'bounce': comment.isNew }]">

                          <Avatar
                            v-if="shouldShowAvatar(comment, comment_index)"
                            class="ml-2 mr-2"
                            :object="comment.user"
                            size="xs"
                          />
                          <div v-else class="ml-2 mr-2 avatar-placeholder"></div>

                          <div class="chat-message">
                            <div v-if="comment.comment && comment.comment.length > 300">
                              <p v-if="comment.expanded" class="text-formatted">
                                {{ comment.comment }}
                              </p>
                              <p v-else class="text-formatted">
                                {{ comment.comment | truncate(300) }}
                              </p>

                              <div class="mt-1" @click="comment.expanded = !comment.expanded">
                                <span class="cursor-pointer" v-if="!comment.expanded">
                                  <span class="mr-2 chat-view-more">{{ $t('system.view_more') }}</span>
                                </span>
                                <span class="cursor-pointer" v-if="comment.expanded">
                                  <span class="mr-2 chat-view-more">{{ $t('system.view_less') }}</span>
                                </span>
                              </div>
                            </div>

                            <p
                                v-if="comment.comment && comment.comment.length <= 300"
                                class="text-formatted"
                            >
                              {{ comment.comment }}
                            </p>
                          </div>

                          <span class="chat-message-datetime">
                            {{ comment.updated_at | formatDateTime }}
                          </span>

                          <span
                            class="delete-button"
                            v-if="isCommentOwner(comment) && selectedTask.status !== 'completed'"
                            @click="openDeleteCommentModal(comment)"
                          >
                            <font-awesome-icon icon="trash-alt" />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div v-if="!loadingComments && !previousComments.length" class="text-center">
                      <h6>
                        {{ $t('system.no_results') }}
                      </h6>
                    </div>
                  </div>

                  <div v-if="previousComments.length" class="chat-message-top-fog"></div>
                </div>

                <div class="mt-3 mb-3">
                  <div class="row" v-if="selectedTask.data_status != 'completed' && selectedTask.status != 'completed'">
                    <div class="chat-box-col-text">
                      <b-form-textarea
                          ref="chatInput"
                          qid="chat-input-field"
                          v-model="comment"
                          class="chat-box-text"
                          rows="1"
                          max-rows="4"
                          :placeholder="$t('tasks.modal.question_to_recipient_label')"
                          @input="resizeChatInput"
                          style="resize:none;overflow-y:hidden;"
                      ></b-form-textarea>
                    </div>
                    <div class="chat-box-col-button cursor-pointer">
                      <div
                          class="btn chat-box-button"
                          @click="handleAddCommentSubmit"
                          v-b-tooltip.hover
                          :title="$t('tasks.modal.send_button_label')"
                      >
                        <font-awesome-icon icon="paper-plane" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      </b-form>

      <!-- Update measures task -->
      <div class="form-container mt-0 mb-2" v-if="selectedTask && selectedTask.code == 'update_measures'">
        <div class="row mt-1">

          <!-- Tables container -->
          <div class="col-sm-12" v-if="selectedTask.project">
            <MeasuresTable :object="selectedTask.project" :showOnTask="true"></MeasuresTable>
          </div>

        </div>
      </div>
  </div>
</template>

<script>
import assessmentSingleTaskProxy from './assessmentSingleTaskProxy';
import Datepicker from 'vuejs-datepicker';
import Avatar from '@/components/Avatar.vue';
import CreateObservationModal from '@/views/Projects/CreateObservationModal.vue';
import ObservationViewModal from '@/views/Projects/ObservationViewModal.vue';
import MeasuresTable from '@/views/Projects/MeasuresTable.vue';
import WordByWord from '@/components/WordByWord.vue';
import AssessmentGlobalSingleTaskModalChatNotesCard from './AssessmentGlobalSingleTaskModalChatNotesCard.vue';

export default {
  name: 'AssessmentGlobalSingleTaskModalBody',
  mixins: [assessmentSingleTaskProxy],
  components: {
    Datepicker,
    Avatar,
    CreateObservationModal,
    ObservationViewModal,
    MeasuresTable,
    WordByWord,
    AssessmentGlobalSingleTaskModalChatNotesCard
  },
  data() {
    return {
      pendingSubmitScroll: false,
      hasInitialScrollRun: false,
      lastCommentsKey: '',
      pollingInterval: null,
      lastCommentsLength: 0
    };
  },
  watch: {
    previousComments: {
      handler(newComments, oldComments) {
        if (!oldComments || oldComments.length === 0) {
          this.isInitialLoad = false;
          return;
        }
        if (newComments.length > oldComments.length) {
          const oldIds = new Set(oldComments.map(c => c.id));
          newComments.forEach(comment => {
            if (!oldIds.has(comment.id)) {
              this.$set(comment, 'isNew', true);
              setTimeout(() => {
                this.$set(comment, 'isNew', false);
              }, 1000);
            }
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeChatInput();
      this.lastCommentsKey = this.getCommentsKey(this.previousComments);
      this.lastCommentsLength = this.previousComments.length;
    });
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  updated() {
    this.$nextTick(() => {
      this.resizeChatInput();

      const comments = this.previousComments || [];
      const nextKey = this.getCommentsKey(comments);
      const commentsChanged = nextKey !== this.lastCommentsKey;

      if (!this.hasInitialScrollRun && comments.length > 0) {
        this.scrollToBottom('smooth');
        this.hasInitialScrollRun = true;
      } else if (commentsChanged) {
        this.scrollToBottom('smooth');
        if (this.pendingSubmitScroll) {
          this.pendingSubmitScroll = false;
        }
      }

      // Detect new comments for bounce animation
      if (comments.length > this.lastCommentsLength) {
        const newComments = comments.slice(this.lastCommentsLength);
        newComments.forEach(comment => {
          this.$set(comment, 'isNew', true);
          setTimeout(() => {
            this.$set(comment, 'isNew', false);
          }, 1000);
        });
      }

      this.lastCommentsKey = nextKey;
      this.lastCommentsLength = comments.length;
    });
  },
  methods: {
    handleAddCommentSubmit() {
      this.pendingSubmitScroll = true;
      this.addCommentSubmit();
      setTimeout(() => {
        if (this.pendingSubmitScroll) {
          this.scrollToBottom('smooth');
        }
      }, 800);
    },
    getCommentsKey(list) {
      if (!list || !list.length) return '0';
      const last = list[list.length - 1] || {};
      return `${list.length}-${last.id || ''}-${last.updated_at || ''}`;
    },
    scrollToBottom(behavior = 'smooth') {
      const container = this.$refs.chatContainer;
      if (!container) return;
      container.scrollTo({
        top: container.scrollHeight,
        behavior
      });
    },
    resizeChatInput() {
      const refRaw = this.$refs.chatInput;
      const ref = Array.isArray(refRaw) ? refRaw[0] : refRaw;
      if (!ref) return;
      const el = ref.$el
          ? (ref.$el.querySelector && ref.$el.querySelector('textarea')) || ref.$el
          : ref;
      if (!el || !el.style) return;
      const min = 36;
      const max = 144;
      el.style.minHeight = `${min}px`;
      el.style.height = 'auto';
      const next = Math.max(min, Math.min(el.scrollHeight || min, max));
      el.style.height = `${next}px`;
      el.style.overflowY = next >= max ? 'scroll' : 'hidden';
    },
    startPolling() {
      this.pollingInterval = setInterval(() => {
        this.loadComments();
      }, 20000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    }
  }
};
</script>
